import { Box, Typography, styled } from "@mui/material";

export function ItemUser({ icon, text, profile }) {
  return (
    <BoxUsers>
      {icon}

      <Typography
        paddingLeft={2}
        variant="h6"
        color={
          profile?.phoneNumberConfirmed || profile?.emailConfirmed
            ? "text.main"
            : "error.main"
        }
      >
        {text}
      </Typography>
    </BoxUsers>
  );
}
const BoxUsers = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  marginTop: theme.spacing(1.5),
  "ion-icon": {
    color: theme.palette.secondary.main,
  },
}));
export default ItemUser;
